<template>
  <breeze-authenticated-layout>
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        Reseller : {{vendor.name}}
      </h2>
    </template>
    <div class="py-12 max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="bg-white overflow-hidden shadow sm:rounded-lg">
            <form @submit.prevent="doUpdate">
                <div class="px-6 py-12">
                    <div class="col-span-8 sm:col-span-2">
                        <breeze-label
                        for="name"
                        value="Reseller Name"
                        />
                        <breeze-input
                        id="name"
                        type="text"
                        class="mt-1 block w-full"
                        placeholder="เช่น บริษัท ตัวอย่าง จำกัด"
                        v-model="form.name"
                        />
                        <breeze-input-error
                        :message="form.errors.name"
                        class="mt-2"
                        />
                    </div>

                    <div class="col-span-8 sm:col-span-2">
                        <breeze-label
                        for="registration_request_hook_url"
                        value="Hook สำหรับ ตอนมีการจดคำขอ"
                        />
                        <breeze-input
                        id="registration_request_hook_url"
                        type="text"
                        class="mt-1 block w-full"
                        placeholder="http://your.api/function"
                        v-model="form.registration_request_hook_url"
                        />
                        <breeze-input-error
                        :message="form.errors.registration_request_hook_url"
                        class="mt-2"
                        />
                    </div>
                    <div class="col-span-8 sm:col-span-2">
                        <breeze-label
                        for="registration_complete_hook_url"
                        value="Hook สำหรับ ตอนมีการอนุมัติคำขอแล้ว"
                        />
                        <breeze-input
                        id="registration_complete_hook_url"
                        type="text"
                        class="mt-1 block w-full"
                        placeholder="http://your.api/function"
                        v-model="form.registration_complete_hook_url"
                        />
                        <breeze-input-error
                        :message="form.errors.registration_complete_hook_url"
                        class="mt-2"
                        />
                    </div>
                </div>

                <div class="md:col-span-2 p-6 text-center">
                    <button
                        class="
                        mt-4
                        px-4
                        py-2
                        bg-blue-900
                        border border-transparent
                        rounded-md
                        text-xl text-white
                        tracking-widest
                        hover:bg-yellow-600
                        active:bg-yellow-700
                        focus:outline-none
                        focus:border-yellow-700
                        focus:shadow-outline-white
                        transition
                        ease-in-out
                        duration-150
                        "
                        :class="{
                        'opacity-50': form.processing || isTrashed,
                        }"
                        :disabled="form.processing || isTrashed"
                    >
                        บันทึก
                    </button>
                </div>
            </form>
        </div>
    </div>
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="bg-white overflow-hidden shadow sm:rounded-lg">
            <div class="text-right mr-8">
              <breeze-secondary-button class="my-2">
                <inertia-link  :href="route('staff.packages.create',{ vendor: vendor.id })" class="underline text-sm text-gray-600 hover:text-gray-900">
                            + New Package
                        </inertia-link>
              </breeze-secondary-button>
            </div>
            <div class="py-12 max-w-7xl mx-auto sm:px-6 lg:px-8">
              <div
                class="
                  bg-white
                  overflow-hidden
                  shadow-sm
                  sm:rounded-lg
                  p-6
                  border-b border-gray-200
                "
              >
                <data-table/>
              </div>
          </div>
      </div>
    </div>
  </breeze-authenticated-layout>
</template>

<script>
import BreezeAuthenticatedLayout from "@/Layouts/Authenticated";
import RegistrationData from "./RegistrationData";
import BreezeButton from "@/Components/Button";
import BreezeSecondaryButton from "@/Components/SecondaryButton";
import BreezeDialogModal from "@/Components/DialogModal";
import BreezeLabel from "@/Components/Label";
import BreezeInputError from "@/Components/InputError";
import BreezeInput from "@/Components/Input";
import DataTable from "./PackageDataTable";

export default {
  props: ["vendor", 'isTrashed'],
  components: {
    BreezeAuthenticatedLayout,
    RegistrationData,
    BreezeButton,
    BreezeDialogModal,
    BreezeSecondaryButton,
    BreezeLabel,
    BreezeInput,
    BreezeInputError,
    DataTable,
  },
  data() {
    return {
      formReject: this.$inertia.form({
        remark: null,
      }),
      form: this.$inertia.form({
        name: this.vendor.name,
        id: this.vendor.id,
        products: this.vendor.products,
        registration_request_hook_url: this.vendor.registration_request_hook_url,
        registration_complete_hook_url: this.vendor.registration_complete_hook_url,
      }),
    };
  },
  methods: {

    doUpdate() {
      this.form.put(route("staff.vendors.update",{vendor:this.vendor.id}), {
        preserveScroll: true,
        onSuccess: () => this.form.reset(),
      });
    },
  },
};
</script>
